module.exports = __webpack_public_path__ + "img/рз_18.07e50a7d.png";